import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {UIArtefakt} from '../../models/uiArtefakt';
import {UiModelService} from '../../services/ui-model.service';
import {EventService} from '../../services/event.service';

@Component({
    selector: 'lv-roeteln',
    templateUrl: './roeteln.component.html',
    styleUrls: ['./roeteln.component.scss'],
    standalone: false
})
export class RoetelnComponent implements AfterViewInit{

  public checked: boolean = false;
  private _uiArtefakt: UIArtefakt;

  constructor(private _uiModelService: UiModelService, private _eventService: EventService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): UIArtefakt {
    return this._uiArtefakt;
  }

  @Input()
  set uiArtefakt(uiArtefakt: UIArtefakt) {
    this._uiArtefakt = uiArtefakt.UIArtefakt[0];
    this.checked = this._uiArtefakt.AntragsabweichungJN;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
  }

  public isRoetelnEnabled(): boolean {
    return this._eventService.roetelnEnabled$.getValue() && this.uiArtefakt.AntragsabweichungZulaessigJN;
  }

  public checkboxClicked(checked: boolean) {
    // this.checked = checked;
    this.uiArtefakt.AntragsabweichungJN = checked;
    this._uiModelService.reloadUiControl(this.uiArtefakt);
  }
}
